module.exports = __webpack_public_path__ + "img/3.c05994d6.jpg";